import { ToastContainerProps } from "react-toastify";

export const backSpaceKeyCode = 8;
export const tabSpacekeyCode = 9;
export const deleteKeyCode = 46;
export const enterKeyCode = 13;
export const arrowLeftKeyCode = 37;
export const arrowUpKeyCode = 38;
export const arrowRightKeyCode = 39;
export const arrowDownKeyCode = 40;
export const copyKeyCode = 67;
export const pasteKeyCode = 86;
export const cutKeyCode = 88;
export const selectAllKeyCode = 65;
export const ctrlKeyCode = 17;
export const undoKeyCode = 90;

export const BulkActionsEntity = {
    download: "download",
    share: "share"
};

export const toastOptObj: ToastContainerProps = {
    position: "top-center",
    autoClose: 3500,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: true,
    theme: "colored",
};

export const JB_GLASS_USER_INFO = "jb_glass_user_info"

export const JB_GLASS_AUTH_TOKEN = "jb_glass_auth_token"

export const JB_GLASS_REMEMBER_ME_DATA = "Jb_glass_rememberMeData"

export const albumsFileExtension = ["jpg", "jpeg", "png", 'gif', 'webp', 'heic'];

export const AllowedVideoExtension = ['ogg', 'ogv', 'mp4', 'm4v', 'webm', 'webmv', 'strm'];

export const AllowedPDFExtension = ['pdf'];

export const AllowedWordExtension = ['docx'];

export const AllowedExcelExtension = ['xlsx', 'csv'];

export const AllowedPPTExtension = ['pptx'];

export const rowsPerPageOptions = [12, 24, 60, 72];

export const imageFileExtension = ["jpeg", "png", "jpg"];

export const glassSubAlbumsNames = ["Opaque", "Translucent", "Transparent"];
